var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-card',{attrs:{"title":_vm.menuName,"notification":("(구)어드민의 '" + _vm.menuName + "' 페이지가 열립니다.")}})}
var staticRenderFns = []

export { render, staticRenderFns }